import { Trans, useTranslation } from "react-i18next";

import util from "utils/utils";

import type { NotificationContentProps } from "../types";

const AnnouncementReport = ({
  context,
  ownerChallenge,
  ownerGroup,
}: NotificationContentProps) => {
  const { t } = useTranslation();

  let contextStr = "your";
  let contextName = "organisation";
  if (ownerChallenge) {
    contextStr = `the ${t("generic.challenge")}`;
    contextName = ownerChallenge.name;
  } else if (ownerGroup) {
    contextStr = `the ${t("generic.group")}`;
    contextName = ownerGroup.name;
  }

  const recipients =
    typeof context?.recipients === "number" ? context.recipients : 0;

  return (
    <Trans
      i18nKey="notifications.announcementReport"
      values={{
        announcement: context?.subject ?? "",
        contextStr,
        contextName,
        recipients: util.pluralise(recipients, "recipient", "recipients"),
      }}
    />
  );
};

export default AnnouncementReport;
